import { useEffect, useState } from "react";
import { Translator } from "./translator";

const About = () => {
  const { translateText, lang } = Translator();

  // --- Base copy in 3 directly supported languages ---
  const baseTextByLang = {
    it: {
      text1: "Informazioni su Te.C.H-e",
      text2: "Tecnologia per il Patrimonio Culturale",
      text3:
        "(Technology for Cultural Heritage) migliora l’accessibilità al patrimonio culturale materiale e immateriale attraverso l’innovazione tecnologica collaborativa.",
      text4:
        "Il progetto promuove esperienze emotive e partecipative supportate da sistemi di raccomandazione che analizzano gli interessi del pubblico e la semantica dei contenuti, creando così uno Smart Cultural Heritage integrato con le Industrie Culturali e Creative.",
      text5:
        "Te.C.H-e combina il Patrimonio Culturale con soluzioni innovative e tecnologie emergenti per garantire esperienze culturali avanzate e accessibili a tutti. Migliora la connettività globale e arricchisce l’intrattenimento indoor grazie alle nuove tecnologie immersive.",
      text6:
        "Progetto cofinanziato da PR CAMPANIA FESR 2021-2027. Asse 1 – Obiettivo specifico 1.1 – Azione 1.1.3 Avviso pubblico Campania Startup 2023 CUP B98I280007010007.",
      text7: "TecheTour",
      text8:
        "è l’infrastruttura informatica del progetto Te.C.H-e. Questa piattaforma/app reinventa l’intrattenimento e il turismo, spostando l’attenzione dalle offerte tradizionali verso esperienze uniche, autentiche e inclusive, grazie alle Tecniche Avanzate.",
      text9: "TecheTour è un servizio",
      text10: "StreamImmersion",
      text11:
        "on demand che combina il concetto di “streaming” con quello di “immersion” in",
      text12: "3D, AR e VR",
      text13:
        ", utilizzando app e piattaforme native, in tempo reale da casa o sul posto, direttamente sul tuo dispositivo in qualsiasi momento.",
      text14:
        "Permette a chiunque di vivere esperienze personalizzate basate sulle proprie preferenze e interessi.",
      textARVR:
        "Le esperienze AR e VR possono essere visualizzate tramite la nostra app mobile disponibile per dispositivi iOS e Android.",
      text3DApp:
        "Le tecnologie immersive 3D avanzate sono disponibili all’interno dell’app TECHE-METAVERSE.",
      text15: "Team di Sviluppo",
      text16:
        "Specialisti in Storia dell’Arte, Cultura Materiale e Immateriale, Informatici, specialisti in tecnologie emergenti, videomaker, storyteller, fotografi, esperti in blockchain, e accademici provenienti dall’Università degli Studi di Napoli Federico II e dall’Università degli Studi di Napoli Parthenope.",
      text22: "Sviluppo software e architettura della piattaforma",
      text23:
        "Lo sviluppo software della piattaforma Te.C.H-e / TecheTour è curato da Omar Samir, Software Engineer e Full-Stack Developer con laurea in Ingegneria dell’Information Technology presso Metropolia University of Applied Sciences (Finlandia). L’attività è svolta sotto il coordinamento del management del progetto. Omar segue l’intera infrastruttura: frontend del sito React.js e Tailwind, backend con python, database Neo4j, sistemi di pagamento con particolare attenzione alla scalabilità, sicurezza e all’esperienza utente.",
      text21: "Tutti i diritti riservati.",
    },

    en: {
      text1: "About Te.C.H-e",
      text2: "Technology for Cultural Heritage",
      text3:
        "(Technology for Cultural Heritage) improves accessibility to both tangible and intangible cultural heritage through collaborative technological innovation.",
      text4:
        "The project promotes emotional and participatory experiences supported by recommendation systems that analyze audience interests and content semantics, creating an integrated Smart Cultural Heritage with Cultural and Creative Industries.",
      text5:
        "Te.C.H-e combines Cultural Heritage with innovative solutions and emerging technologies to deliver advanced and accessible cultural experiences for everyone. It enhances global connectivity and enriches indoor entertainment thanks to new immersive technologies.",
      text6:
        "Project co-funded by PR CAMPANIA FESR 2021-2027. Axis 1 – Specific Objective 1.1 – Action 1.1.3 Public Notice Campania Startup 2023 CUP B98I280007010007.",
      text7: "TecheTour",
      text8:
        "is the digital infrastructure of the Te.C.H-e project. This platform/app reinvents entertainment and tourism by shifting attention from traditional offerings toward unique, authentic, and inclusive experiences through Advanced Techniques.",
      text9: "TecheTour is a",
      text10: "StreamImmersion",
      text11:
        "on-demand service combining the concept of “streaming” with “immersion” in",
      text12: "3D, AR and VR",
      text13:
        ", using native apps and platforms, in real time from home or on-site, directly from your device at any moment.",
      text14:
        "It allows anyone to experience personalized cultural journeys based on their preferences and interests.",
      textARVR:
        "AR and VR experiences can be viewed through our mobile app, available for iOS and Android.",
      text3DApp:
        "Advanced 3D immersive technologies are available inside the TECHE-METAVERSE app.",
      text15: "Development Team",
      text16:
        "Specialists in Art History, Tangible and Intangible Culture, Computer Science, emerging technologies, videomaking, storytelling, photography, blockchain, and academics from the University of Naples Federico II and the University of Naples Parthenope.",
      text22: "Software development and platform architecture",
      text23:
        "The software development of the Te.C.H-e / TecheTour platform is carried out by Omar Samir, Software Engineer and Full-Stack Developer with a degree in Information Technology Engineering from Metropolia University of Applied Sciences (Finland). The activity is coordinated under the project management. Omar follows the entire infrastructure: site frontend in React.js + Tailwind, backend in Python, Neo4j database, payment systems, with strong focus on scalability, security, and user experience.",
      text21: "All rights reserved.",
    },

    fr: {
      text1: "Informations sur Te.C.H-e",
      text2: "Technologie pour le Patrimoine Culturel",
      text3:
        "(Technology for Cultural Heritage) améliore l’accessibilité au patrimoine culturel matériel et immatériel grâce à l’innovation technologique collaborative.",
      text4:
        "Le projet promeut des expériences émotionnelles et participatives soutenues par des systèmes de recommandation qui analysent les intérêts du public et la sémantique des contenus, créant ainsi un Smart Cultural Heritage intégré aux Industries Culturelles et Créatives.",
      text5:
        "Te.C.H-e combine le Patrimoine Culturel avec des solutions innovantes et des technologies émergentes pour garantir des expériences culturelles avancées et accessibles à tous. Il améliore la connectivité mondiale et enrichit le divertissement intérieur grâce aux nouvelles technologies immersives.",
      text6:
        "Projet cofinancé par PR CAMPANIA FESR 2021-2027. Axe 1 – Objectif spécifique 1.1 – Action 1.1.3 Appel public Campania Startup 2023 CUP B98I280007010007.",
      text7: "TecheTour",
      text8:
        "est l’infrastructure numérique du projet Te.C.H-e. Cette plateforme/app réinvente le divertissement et le tourisme en déplaçant l’attention des offres traditionnelles vers des expériences uniques, authentiques et inclusives, grâce aux Techniques Avancées.",
      text9: "TecheTour est un service",
      text10: "StreamImmersion",
      text11:
        "à la demande qui combine le concept de « streaming » avec celui d’« immersion » en",
      text12: "3D, AR et VR",
      text13:
        ", utilisant des applications et plateformes natives, en temps réel depuis chez vous ou sur place, depuis votre appareil à tout moment.",
      text14:
        "Il permet à chacun de vivre des expériences personnalisées basées sur ses préférences et intérêts.",
      textARVR:
        "Les expériences AR et VR peuvent être visualisées via notre application mobile disponible pour iOS et Android.",
      text3DApp:
        "Les technologies immersives 3D avancées sont disponibles dans l’application TECHE-METAVERSE.",
      text15: "Équipe de développement",
      text16:
        "Des spécialistes en Histoire de l’Art, Culture Matérielle et Immatérielle, Informatique, technologies émergentes, vidéographie, storytelling, photographie, blockchain, ainsi que des universitaires de l’Université de Naples Federico II et de l’Université de Naples Parthenope.",
      text22: "Développement logiciel et architecture de la plateforme",
      text23:
        "Le développement logiciel de la plateforme Te.C.H-e / TecheTour est réalisé par Omar Samir, Software Engineer et Full-Stack Developer diplômé en Ingénierie des Technologies de l’Information à Metropolia University of Applied Sciences (Finlande). L’activité est effectuée sous la coordination de la direction du projet. Omar gère toute l’infrastructure : frontend en React.js + Tailwind, backend en Python, base de données Neo4j, systèmes de paiement, avec une attention particulière à la scalabilité, la sécurité et l’expérience utilisateur.",
      text21: "Tous droits réservés.",
    },

    es: {
      text1: "Acerca de Te.C.H-e",
      text2: "Tecnología para el Patrimonio Cultural",
      text3:
        "(Tecnología para el Patrimonio Cultural) mejora la accesibilidad al patrimonio cultural tanto tangible como inmaterial a través de la innovación tecnológica colaborativa.",
      text4:
        "El proyecto promueve experiencias emocionales y participativas respaldadas por sistemas de recomendación que analizan los intereses de la audiencia y la semántica del contenido, creando un Patrimonio Cultural Inteligente integrado con las Industrias Culturales y Creativas.",
      text5:
        "Te.C.H-e combina el Patrimonio Cultural con soluciones innovadoras y tecnologías emergentes para ofrecer experiencias culturales avanzadas y accesibles para todos. Mejora la conectividad global y enriquece el entretenimiento en interiores gracias a las nuevas tecnologías inmersivas.",
      text6:
        "Proyecto cofinanciado por PR CAMPANIA FESR 2021-2027. Eje 1 – Objetivo específico 1.1 – Acción 1.1.3 Convocatoria pública Campania Startup 2023 CUP B98I280007010007.",
      text7: "TecheTour",
      text8:
        "es la infraestructura digital del proyecto Te.C.H-e. Esta plataforma/aplicación reinventa el entretenimiento y el turismo al cambiar la atención de las ofertas tradicionales hacia experiencias únicas, auténticas e inclusivas a través de Técnicas Avanzadas.",
      text9: "TecheTour es un",
      text10: "StreamImmersion",
      text11:
        "servicio bajo demanda que combina el concepto de “streaming” con “inmersión” en",
      text12: "3D, AR y VR",
      text13:
        ", usando aplicaciones nativas y plataformas, en tiempo real desde casa o in situ, directamente desde tu dispositivo en cualquier momento.",
      text14:
        "Permite a cualquiera experimentar viajes culturales personalizados basados en sus preferencias e intereses.",
      textARVR:
        "Las experiencias de AR y VR se pueden ver a través de nuestra aplicación móvil, disponible para iOS y Android.",
      text3DApp:
        "Las tecnologías inmersivas 3D avanzadas están disponibles dentro de la aplicación TECHE-METAVERSE.",
      text15: "Equipo de Desarrollo",
      text16:
        "Especialistas en Historia del Arte, Cultura Tangible e Intangible, Ciencias de la Computación, tecnologías emergentes, videomaking, narrativa, fotografía, blockchain y académicos de la Universidad de Nápoles Federico II y la Universidad de Nápoles Partenope.",
      text22: "Desarrollo de software y arquitectura de la plataforma",
      text23:
        "El desarrollo de software de la plataforma Te.C.H-e / TecheTour es llevado a cabo por Omar Samir, Ingeniero de Software y Desarrollador Full-Stack con una licenciatura en Ingeniería en Tecnología de la Información de la Universidad Metropolia de Ciencias Aplicadas (Finlandia). La actividad está coordinada bajo la gestión del proyecto. Omar sigue toda la infraestructura: frontend del sitio en React.js + Tailwind, backend en Python, base de datos Neo4j, sistemas de pago, con un fuerte enfoque en escalabilidad, seguridad y experiencia del usuario.",
      text21: "Todos los derechos reservados.",
    },
  };

  // Initial text: if lang is one of the 3, use it; otherwise default to Italian
  const [translatedText, setTranslatedText] = useState(
    baseTextByLang[lang] || baseTextByLang.it
  );

  useEffect(() => {
    // Directly supported languages → no API calls
    if (lang === "it" || lang === "en" || lang === "fr") {
      setTranslatedText(baseTextByLang[lang]);
      return;
    }

    // Other languages → translate from Italian with Translator()
    let cancelled = false;

    const translateAll = async () => {
      const entries = Object.entries(baseTextByLang.it);
      const translatedEntries = await Promise.all(
        entries.map(async ([key, value]) => {
          const out = await translateText(value);
          return [key, out || value];
        })
      );

      if (!cancelled) {
        setTranslatedText(Object.fromEntries(translatedEntries));
      }
    };

    translateAll();

    return () => {
      cancelled = true;
    };
  }, [lang, translateText]);

  return (
    <div className="about-container px-5 py-6 max-w-3xl mx-auto leading-relaxed text-gray-900">
      <h1 className="text-3xl font-bold text-center mb-2">
        {translatedText.text1}
      </h1>

      <h2 className="text-xl text-black font-semibold mb-4 text-center">
        {translatedText.text2}
      </h2>

      <p className="mb-3">
        <strong>Te.C.H-e</strong> {translatedText.text3}
      </p>

      <p className="mb-3">{translatedText.text4}</p>

      <p className="mb-4">{translatedText.text5}</p>

      <footer className="text-sm mt-4 mb-8">{translatedText.text6}</footer>

      <hr className="my-8" />

      {/* TecheTour Section */}
      <h2 className="text-xl text-black font-semibold mt-4 mb-2 text-center">
        {translatedText.text7}
      </h2>

      <p className="mb-3">
        <strong>{translatedText.text7}</strong> {translatedText.text8}
      </p>

      <p className="mb-3">
        {translatedText.text9} <strong>{translatedText.text10}</strong>{" "}
        {translatedText.text11} <strong>{translatedText.text12}</strong>
        {translatedText.text13}
      </p>

      <p className="mb-3">{translatedText.text14}</p>

      {/* Extra facts */}
      <p className="mb-3">
        <strong>•</strong> {translatedText.textARVR}
      </p>
      <p className="mb-6">
        <strong>•</strong> {translatedText.text3DApp}
      </p>

      {/* Team */}
      <h2 className="text-xl text-black font-semibold mt-6 mb-2 text-center">
        {translatedText.text15}
      </h2>

      <p className="mb-3">{translatedText.text16}</p>

      {/* Omar */}
      <h2 className="text-lg text-black font-semibold mt-4 mb-2">
        {translatedText.text22}
      </h2>

      <p className="mb-6">{translatedText.text23}</p>

      <hr className="my-8" />

      <footer className="text-sm mt-6">
        © Te.C.H-e – {translatedText.text21}
      </footer>
    </div>
  );
};

export default About;
